import { render, staticRenderFns } from "./RetroactiveSpreadSuggestion.vue?vue&type=template&id=11039278&scoped=true"
import script from "./RetroactiveSpreadSuggestion.vue?vue&type=script&lang=js"
export * from "./RetroactiveSpreadSuggestion.vue?vue&type=script&lang=js"
import style0 from "./RetroactiveSpreadSuggestion.vue?vue&type=style&index=0&id=11039278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11039278",
  null
  
)

export default component.exports